import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isSuperAdmin, useAuthenticationService } from '../authentication-service';

export const RequireSuperAdmin: FC = () => {
  const location = useLocation();
  const [role] = useAuthenticationService(state => [state.role]);

  if (!isSuperAdmin(role)) {
    return <Navigate to={'*'} replace={true} state={{ restore: location.pathname }} />;
  }

  return <Outlet />;
};
